"use client";

/**
This client-only component exists only to immediately attempt to sign in the
user with next-auth. It has to be a client component because the signIn function
only works from the client.

If you need to sign in a user, redirect them to this route ("/autoLogin") and
pass the path and search params you came from via a "?from=..." query param.

This allows us to pass the proper callback URL to zapier.com's sign in page, so
the user ends up back where they started after logging in (and not on this route
that doesn't render anything).
*/
import { signIn } from "next-auth/react";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

export default function AutoLogin() {
  const searchParameters = useSearchParams();
  const callbackPath = searchParameters?.get("from") || "";

  useEffect(() => {
    // This needs to be in an effect to ensure it runs on the client.
    signIn("zapier", {
      callbackUrl: globalThis.location.origin + callbackPath,
    });
  }, [callbackPath]);

  return null;
}
